import { useSyncExternalStore } from "react";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { AppDialog } from "../../components/AppDialog";
import { AppDialogHeader } from "../../components/AppDialogHeader";
import { subscribePicker, getCurrentPicker, resolveAlbumPick } from "../../../albumPickerBus";

export function AlbumPickerDialog() {
  const request = useSyncExternalStore(subscribePicker, getCurrentPicker);
  if (!request) return null;

  return (
    <AppDialog open onClose={() => resolveAlbumPick(null)} maxWidth="xs" fullWidth>
      <AppDialogHeader title={request.title} onBack={() => resolveAlbumPick(null)} />
      <DialogContent sx={{ p: 4, pt: 2 }}>
        <Box sx={{ display: "grid", gap: 1 }}>
          {!request.targets.length && (
            <Typography variant="body2" color="text.secondary">
              No albums yet.
            </Typography>
          )}
          {request.targets.map((album) => (
            <Button
              key={album.id}
              variant="outlined"
              color="primary"
              sx={{ justifyContent: "flex-start" }}
              onClick={() => resolveAlbumPick({ id: album.id, name: album.name })}
            >
              <i className="bi bi-folder-fill me-2" aria-hidden="true" style={{ marginRight: 8 }} />
              {album.name}
            </Button>
          ))}
        </Box>
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          sx={{ mt: 3 }}
          onClick={() => resolveAlbumPick(null)}
        >
          Cancel
        </Button>
      </DialogContent>
    </AppDialog>
  );
}
